import React from "react";
import { connect } from "react-redux";
import { Dropdown, Row, Col, Button } from "react-bootstrap";
import { removeCartItemFromCart, getCartTotal } from "../actions";

const ShoppingCart = ({ dispatch, cart_items, cart_total }) => {
  if (!cart_items || cart_items.length === 0) {
    return (
      <div className="cart-nav-dropdown">
        <Dropdown>
          <Dropdown.Toggle variant="link" id="cart-dropdown" className="nav-link">
            Cart ($0.00)
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-custom dropdown-menu-right">
            <Dropdown.Item className="text-center py-3">
              Your cart is empty
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  return (
    <div className="cart-nav-dropdown">
      <Dropdown>
        <Dropdown.Toggle variant="link" id="cart-dropdown" className="nav-link">
          Cart ({cart_total})
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-custom dropdown-menu-right cart-dropdown-menu">
          {cart_items.map((cart_item) => (
            <Dropdown.Item className="cart-drop-item py-2" key={cart_item.id}>
              <Row className="no-gutters">
                <Col xs={3} className="cart-img-col pr-2">
                  <img
                    className="cart-item-img img-fluid"
                    src={cart_item.image}
                    alt={cart_item.name}
                  />
                </Col>
                <Col xs={6} className="cart-item-name align-self-center">
                  <span className="cart-item-name-title">{cart_item.name}</span>
                  <br />
                  <small>{cart_item.short_description}</small>
                </Col>
                <Col xs={3} className="align-self-center text-right">
                  <h5 className="mb-1">${cart_item.price}</h5>
                  <Button
                    variant="link"
                    size="sm"
                    className="remove-button p-0"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      dispatch(removeCartItemFromCart(cart_item.id));
                    }}
                  >
                    <i className="fa fa-minus"></i> Remove
                  </Button>
                </Col>
              </Row>
            </Dropdown.Item>
          ))}

          <Dropdown.Divider />

          <Dropdown.Item
            href="/shopping_cart/checkout"
            className="checkout-item py-3"
            onClick={(e) => e.stopPropagation()}
          >
            <Button
              variant="primary"
              className="checkout-button btn-block"
            >
              <i className="fa fa-shopping-cart mr-2"></i>
              Checkout {cart_total}
            </Button>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

const mapStateToProps = state => ({
  cart_items: state.cart_items,
  cart_total: getCartTotal(state.cart_items)
});

export default connect(mapStateToProps)(ShoppingCart);
